import { Annotations } from 'plotly.js'
import { useWindowSize } from 'react-use'
import { ScatterPlotMetadata } from 'redux/slices'
import { useCellVisualizationsSlice } from 'redux/slices/hooks/useCellVisualizationsSlice'
import { getFixedAnnotation } from './utils'

export const useDragHandlerAnnotations = ({
  maxX,
  maxY: _maxY,
  minX,
  minY: _minY,
}: ScatterPlotMetadata): {
  dragHandlerAnnotations: Partial<Annotations>[]
} => {
  const { height: windowHeight } = useWindowSize()
  const bannerHeight = 50 / windowHeight

  const {
    visibleSelectedComparisonDimensions,
    cellVisualizations: { groupCompare }
  } = useCellVisualizationsSlice()

  const dragHandlerAnnotations = [] as Partial<Annotations>[]

  // Only show drag handlers when drag/drop is enabled and we have comparison dimensions
  const dragDropEnabled = groupCompare?.dragDropEnabled ?? false
  
  if (!visibleSelectedComparisonDimensions?.length || !dragDropEnabled) {
    return { dragHandlerAnnotations }
  }

  const width = maxX - minX
  const middleWidth = (maxX + minX) / 2

  if (visibleSelectedComparisonDimensions?.[0]?.values) {
    visibleSelectedComparisonDimensions[0].values.forEach((_value, i) => {
      const dragHandlerAnnotation = getFixedAnnotation({
        text: '⠿',
        fixed: 'y',
        x: middleWidth + width * 1.5 * i, 
        y: 1 - bannerHeight * 0.8,
      })
      
      dragHandlerAnnotations.push({
        ...dragHandlerAnnotation,
        font: {
          ...dragHandlerAnnotation.font,
          size: 16,
          color: 'rgba(73, 80, 87, 1)',
          family: 'monospace'
        },
        bgcolor: 'rgba(255, 255, 255, 0.9)',
        bordercolor: 'rgba(108, 117, 125, 0.8)',
        borderwidth: 1,
        borderpad: 4,
        captureevents: false,
      })
    })
  }

  return { dragHandlerAnnotations }
}

export default useDragHandlerAnnotations
